export default __webpack_public_path__ + "static/media/Cable Monk.5715981c.png";